import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';
import { selectUserActiveEmployerInfo } from 'store/user/selectors.js/user.selectors';
import { getOrganizationChartResources } from '../services/getOrganizationChartResources.service';

export const loadProjectOrganizationChartResources = createAsyncThunk(
  'organizationCharts/loadProjectOrganizationChartResources',
  async (_, { getState }) => {
    const selectedProjectId = selectSelectedProjectId(getState());

    const activeEmployerInfo = selectUserActiveEmployerInfo(getState());

    const response = await getOrganizationChartResources(
      selectedProjectId,
      activeEmployerInfo
    );

    return response;
  }
);
